import "./App.css";
import { GoMail } from "react-icons/go";
import { FaInstagram } from "react-icons/fa";
import { SlSocialSpotify } from "react-icons/sl";
import Logo from "./Media/Logo.svg";
import emailjs from "@emailjs/browser";

import { useEffect, useRef, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import AudioPlayerButton from "./AudioPlayerBtn";
import Bg1 from "./Media/bg-red.jpg";
import Bg2 from "./Media/bg-pink.jpg";
import Bg3 from "./Media/bg-purple.jpg";

const quotes = [
  `"Massage your own heart. Massage your heart with the palm of your hand. Know that there is a presence — a heart — inside of you. Love your own heart. Never forget: you own a heart."`,
  `“The assumption that the greater version of you is your higher self? You are limitless. You ARE the Most High—never ending.”`,
  `"Breathe into your heart. Feel its rhythm. That is your reminder that you are here, now, with purpose."`,
  `“Failure is success achieved if ‘winning’ is ‘losing’ believed.”`,
];

function App() {
  const [quoteIndex, setQuoteIndex] = useState(0);
  const bgImages = [Bg1, Bg2, Bg3];
  const [bgIndex, setBgIndex] = useState(0);
  const [currentLayer, setCurrentLayer] = useState(0);

  const backgroundRefs = [useRef(null), useRef(null)];
  const [isModalOpen, setModalOpen] = useState(false);
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      const nextQuote = (quoteIndex + 1) % quotes.length;
      const nextBg = (bgIndex + 1) % bgImages.length;
      const nextLayer = 1 - currentLayer;

      backgroundRefs[
        nextLayer
      ].current.style.backgroundImage = `url(${bgImages[nextBg]})`;

      backgroundRefs[nextLayer].current.classList.add("active");
      backgroundRefs[currentLayer].current.classList.remove("active");

      setQuoteIndex(nextQuote);
      setBgIndex(nextBg);
      setCurrentLayer(nextLayer);
    }, 20000);

    return () => clearInterval(interval);
  }, [quoteIndex, bgIndex, currentLayer]);

  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_wruxit8",
        "template_4cepohl",
        form.current,
        "ruZABujQuvWWA0pjp"
      )
      .then(
        (result) => {
          setModalOpen(false);
          setIsConfirmationModalOpen(true);
          e.target.reset();
        },
        (error) => {
          console.log(error.text);
           alert("Something went wrong. Please try again later.");
        }
      );
  };

  const openModal = () => setModalOpen(true);
  const closeModal = () => setModalOpen(false);

  const handleBackgroundClick = (e) => {
    if (e.target.className === "modal") {
      closeModal();
    }
  };

  const closeConfirmationModal = () => {
    setIsConfirmationModalOpen(false);
  };

  return (
    <div className="home">
      <div className="background-container">
        <div
          ref={backgroundRefs[0]}
          className="background-layer active"
          style={{ backgroundImage: `url(${bgImages[0]})` }}
        />
        <div ref={backgroundRefs[1]} className="background-layer" />
      </div>
      <div className="home-top">
        <img src={Logo} alt="logo" />
      </div>

      <div className="home-middle">
        <AnimatePresence mode="wait">
          <motion.p
            key={quoteIndex}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 2 }}
          >
            {quotes[quoteIndex]}
          </motion.p>
        </AnimatePresence>
      </div>

      <div className="home-bottom">
        <AudioPlayerButton />
        <div className="socials">
          <a onClick={openModal}>
            <GoMail />
          </a>
          <a
            href="https://instagram.com/belovegram"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaInstagram />
          </a>
          <a
            href="https://open.spotify.com/artist/70c5RuFuhLfxsZULoJTOTK?si=2_KtEzqaRny_R1ISMZQ21w"
            target="_blank"
            rel="noopener noreferrer"
          >
            <SlSocialSpotify />
          </a>
        </div>
        <h6 className="copyright">&copy; 2025 be.love</h6>
      </div>

      {isModalOpen && (
        <div className="modal" onClick={handleBackgroundClick}>
          <div className="modal-content">
            <button className="close-button" onClick={closeModal}>
              ×
            </button>
            <h2>HELLO LOVE</h2>
            <form ref={form} onSubmit={sendEmail}>
              <input
                type="text"
                name="user_name"
                placeholder="Full Name"
                required
              />
              <input
                type="email"
                name="user_email"
                placeholder="Email Address"
                required
              />
              <input
                type="tel"
                name="user_number"
                placeholder="Phone Number"
                required
              />
              <input type="text" name="subject" placeholder="Subject" />
              <textarea
                rows={7}
                name="message"
                placeholder="Message"
                required
              ></textarea>
              <button type="submit">Send Message</button>
            </form>
          </div>
        </div>
      )}
      {isConfirmationModalOpen && (
        <div className="modal">
          <div className="modal-submitted">
            <p>Thank you for your message.</p>
            <p>We'll be in touch with you soon.</p>
            <button className="confirm-btn" onClick={closeConfirmationModal}>
              Return
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
